import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {

  saleAmount: ".animation--item.animation--order-1",
  saleItems: ".animation--item:not(.animation--order-1)",
  containerItems: ".animation--container > *",
};

export default node => {
  const leftColumnItems = [selectors.saleAmount, selectors.saleItems];
  const rightColumnItems = [selectors.containerItems];

  // Add the animation delay offset variables
  delayOffset(node, leftColumnItems);
  delayOffset(node, rightColumnItems, 1);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
